import { getReinsuranceYear } from '@harvestiq/utils'
import {
  COMMODITY_CATTLE,
  getCommodityFromFinishingTypeCode,
} from './commodity'
import { isNullOrUndefined } from './validations'

const tooltipTitleMap = {
  endingValue: ['Expected Ending Value', 'Actual Ending Value'],
  indemnity: ['Expected Indemnity', 'Actual Indemnity'],
  grossMargin: ['Expected Gross Margin', 'Guaranteed Gross Margin'],
}

export const getToolTipTitle = (key, value) =>
  tooltipTitleMap[key]?.[+!isNullOrUndefined(value)] // value to index

const lrpCoverageSubsidyRateInfo = [
  {
    coverageLevelLow: 0.95,
    // Max value used to ensure all values above 0.95 resolve
    coverageLevelHi: Number.MAX_VALUE,
    subsidyRate: 0.35,
  },
  {
    coverageLevelLow: 0.9,
    coverageLevelHi: 0.95,
    subsidyRate: 0.4,
  },
  {
    coverageLevelLow: 0.85,
    coverageLevelHi: 0.9,
    subsidyRate: 0.45,
  },
  {
    coverageLevelLow: 0.8,
    coverageLevelHi: 0.85,
    subsidyRate: 0.5,
  },
  {
    coverageLevelLow: 0.7,
    coverageLevelHi: 0.8,
    subsidyRate: 0.55,
  },
]

// According to https://www.rma.usda.gov/ftp/Publications/M13_Handbook/2024/approved/P16_1_Plan_82_Premium_Calculation.PDF
// Beginning Farmer/Rancher and Veteran Farmer/Rancher (BFR/VFR) Premium Discount is 10%
const bfrVfrPremiumDiscount = 0.1

export const getBfrVfrPremiumDiscount = isBeginningOrVeteranFarmerRancher =>
  isBeginningOrVeteranFarmerRancher ? bfrVfrPremiumDiscount : 0

export const rmaReinsuranceYears = {
  year2024: 2024,
  year2023: 2023,
  year2022: 2022,
}

// This factor has potential to change from year to year and has no known name in the RMA documentation
// We are calling it the Simulated Losses Adjustment Factor (SLAF)
// See See Section 4, Total Premium Amount calc in https://www.rma.usda.gov/ftp/Publications/M13_Handbook/2024/approved/P16_1_Plan_82_Premium_Calculation.PDF
export const getLgmSimulatedLossesAdjustmentFactor = salesEffectiveDate => {
  const reinsuranceYear = getReinsuranceYear(salesEffectiveDate)

  if (reinsuranceYear >= rmaReinsuranceYears.year2024) {
    return 1.0638 / 500
  }
  if (
    reinsuranceYear === rmaReinsuranceYears.year2022 ||
    reinsuranceYear === rmaReinsuranceYears.year2023
  ) {
    return 1.03 / 500
  }
  return 1.03 / 5000
}

export const getLgmOverhead = salesEffectiveDate => {
  const reinsuranceYear = getReinsuranceYear(salesEffectiveDate)

  if (reinsuranceYear >= rmaReinsuranceYears.year2024) {
    return 1.0638
  }
  if (
    reinsuranceYear === rmaReinsuranceYears.year2022 ||
    reinsuranceYear === rmaReinsuranceYears.year2023
  ) {
    return 1.03
  }
  return 1.03
}

// FIXME is this year dependent?
export const getLgmSubsidyRatio = (finishingTypeCode, deductible) => {
  const commodity = getCommodityFromFinishingTypeCode(finishingTypeCode)
  if (commodity == COMMODITY_CATTLE) {
    switch (deductible) {
      case 0:
        return 0.18
      case 10:
        return 0.2
      case 20:
        return 0.23
      case 30:
        return 0.27
      case 40:
        return 0.31
      case 50:
        return 0.36
      case 60:
        return 0.43
      default:
        return 0.5
    }
  } else {
    // swine
    switch (deductible) {
      case 0:
        return 0.18
      case 2:
        return 0.23
      case 4:
        return 0.29
      case 6:
        return 0.34
      case 8:
        return 0.39
      case 10:
        return 0.45
      default:
        return 0.5
    }
  }
}

export const getLrpCoverageSubsidyRate = coverageLevel => {
  const subsidyRate = lrpCoverageSubsidyRateInfo.find(
    rateInfo =>
      coverageLevel < rateInfo.coverageLevelHi &&
      coverageLevel >= rateInfo.coverageLevelLow,
  )?.subsidyRate
  return subsidyRate
}

export const agentSignedDateRequiredMessage =
  'Agent sign date is required for submission. It has been set to the date of AIP submission.'
